import clsx from "clsx";
import React, { ReactNode, useContext, useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

import { CircleButton, CircleButtonProps } from "./circle_button";

import { MenuContext, MenuProvider } from "contexts/menu";

import "./menu.scss";

type MenuProps = CircleButtonProps & {
  ariaLabel?: string;
  children?: ReactNode;
  darkMode?: boolean;
  title?: string;
  IconComponent?: React.ElementType;
  Icon?: React.ReactNode;
  MenuButtonComponent?: React.ElementType;
  isMobile?: boolean;
};

function Menu(props: MenuProps) {
  return (
    <MenuProvider>
      <WrappedMenu {...props} />
    </MenuProvider>
  );
}

function WrappedMenu(props: MenuProps) {
  const ref = useRef(null);
  const { isMobile = false, MenuButtonComponent } = props;
  const { isOpen, closeMenu, toggleMenu } = useContext(MenuContext);

  useOnClickOutside(ref, () => {
    closeMenu();
  });

  return (
    <div ref={ref} className={clsx("menu relative", { "open-menu": isOpen })}>
      {MenuButtonComponent ? (
        <MenuButtonComponent onClick={toggleMenu} />
      ) : (
        <CircleButton onClick={toggleMenu} {...props} />
      )}
      {isOpen ? (
        <div
          className={clsx("menu-items absolute bg-white py2 body-s", {
            "left-0": isMobile,
            "right-0": !isMobile,
          })}
        >
          {props.children}
        </div>
      ) : null}
    </div>
  );
}

export { Menu, WrappedMenu };
